import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {SCORES_LIST_WIDGET} from "../scores-list-widget.consts";
import {ACTION_TYPES} from "../../../core/consts";
import {ScoresListWidgetController} from "../scores-list-widget.controller";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {ShowAllClickEvent} from "../models/scores-list.show-all-click-event";
import {APP} from "../../../core/app/consts";

export class ScoresListWidgetShowAllClickHandler extends ActionHandler {
  type = SCORES_LIST_WIDGET.ACTION_TYPES.showAll;
  controller: ScoresListWidgetController;

  static injectables = [...ActionHandler.injectables, AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super();

    this.analyticsService = analyticsService;
  }

  async action() {
    this.appStore.state.showAllScores = true;

    this._sendAnalyticsEvent();

    this.controller.action(ACTION_TYPES.fetch, {isPartialFetch: true, force: true});
  }

  _sendAnalyticsEvent() {
    const event: ShowAllClickEvent = new ShowAllClickEvent(APP.ANALYTICS.SOURCES.scores);
    this.analyticsService.createEvent(event);
  }
}
